import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector } from 'react-redux';

import type { GlobalState } from '../index';

export const useAppSelector: TypedUseSelectorHook<GlobalState> = useSelector;
